/* eslint-disable func-names */
import { object, boolean } from 'yup';
import { getExtraQuestionsConditions } from '../../helper';

export default (policyType, quote, isAgency) => {
  const { opposingPolicySoldByAgency } = getExtraQuestionsConditions(quote, policyType, isAgency);

  if (!opposingPolicySoldByAgency) {
    return null;
  }

  return object().shape({
    opposingPolicySoldByAgency: boolean().nullable().required(' ')
  });
};
